import { useCallback, useEffect, useMemo, useState } from 'react'
import { Modal, ModalProps } from '@elements/modal'
import { Button } from '@elements/button'
import { GuestlistForm } from './guestlist-form'
import { GuestlistConfirmationCopy } from './guestlist-confirmation-copy'

import { AdmissionGroup } from 'types/model/admission-group'
import { Venue } from 'types/model'

export function GuestlistModal({
  venue,
  date,
  attributionId,
  affiliateId,
  ...modalProps
}: {
  venue?: Venue
  date: string
  attributionId?: string | null
  affiliateId?: string | null
} & ModalProps) {
  const [status, setStatus] = useState<AdmissionGroup['status']>()

  const afterSubmit = useCallback((vals: AdmissionGroup) => {
    setStatus(vals.status)
  }, [])

  const title = useMemo(() => {
    switch (status) {
      case 'CONFIRMED':
        return `You're on the Guestlist!`
      case 'PENDING':
        return 'Request Received'
      default:
        return 'Get on the Guestlist'
    }
  }, [status])

  useEffect(() => {
    if (!modalProps.isOpen) {
      setTimeout(() => {
        setStatus(undefined)
      }, 500)
    }
  }, [modalProps.isOpen])

  if (!venue) return null
  return (
    <Modal {...modalProps} fit title={title}>
      <div className='w-full max-w-full space-y-6 sm:max-w-xl sm:mx-auto'>
        {!status ? (
          <GuestlistForm
            venue={venue}
            date={date}
            afterSubmit={afterSubmit}
            attributionId={attributionId}
            affiliateId={affiliateId}
          />
        ) : (
          <GuestlistConfirmationCopy date={date} status={status} />
        )}
        {status && (
          <Button.Primary onClick={modalProps.close} className='w-full'>
            Close
          </Button.Primary>
        )}
      </div>
    </Modal>
  )
}
